export const reactStorageKeys = {
  CONFIG: 'REACT_CONFIG',
  CONFIG_EXPIRY: 'REACT_CONFIG_EXPIRY',
  EXPIRY_TIME: 3600000, // THIS IS MILLISECONDS
};

export const MOBILE_VERIFICATION_URL = '/user/mobile_verification';
export const LOGIN_SIGNUP_START = 'login_signup_start';
export const LOGIN_PROCEED_CLICKED = 'login_proceed_clicked';
export const GOOGLE_ONE_TAP_CLOSED = 'google_one_tap_closed';
export const GOOGLE_ONE_TAP_CLICK = 'google_one_tap_click';
export const GOOGLE_ONE_EXPERIEMNT = 'loginType=googleOneLinkExperiment';
export const LOGINTYPE = {
  PHONE_EMAIL: 'phone_email',
  EMAIL: 'email',
  PHONE: 'phone',
  TRUECALLER: 'trueCaller',
  FACEBOOK: 'facebook',
  GOOGLE: 'google',
  GOOGLE_ONE_TAP: 'googleOneTap',
};
export const LOGIN_LOCATION = {
  MYACCOUNT_LOGIN_BTN: 'myAccount_login_btn',
  WISHLISTICON_PRODUCT: 'wishlistIcon_product',
  PLP_ADD_TO_PINKBOX: 'plp_add_to_pinkbox',
  COUPON_OFFERS: 'coupon_offers',
  BUY_NOW: 'buyNow',
};

export const LOGIN_INTERACTION = {
  COUPON_OFFERS: 'coupon_offers',
};
export const AUTH_URL = '/auth';
export const LOGIN_WIDGET = 'loginWidget';
export const LOGIN_NUDGE = 'loginNudge';

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const OTP_LOGIN_CAPTCHA_ERROR = 'error in Login with OTP Captcha';
export const LOGIN_ATTEMPT = 'login_attempt';
export const LOGOUT_START = 'logout_start';
export const PRIVE_TIER_KEY = 'PRIVE_TIER';
export const WELCOME_PAGE = 'welcomePage';
export const IOC_VALUE = 'IOC_VALUE';

export const LOGIN = 'login';
export const SIGNUP = 'signup';

export const OTP_AUTOREAD_ERROR = 'Error reading web otp';
export const CAPTCHA_ERROR = 'error in Login with Password Captcha';
